import z from "zod";
export const FileFigmaRenderMode = z.enum(["Image", "HTML", "JSON"]);
export const FileSourceUpload = z.object({
    type: z.literal("UserUpload"),
    userId: z.string(),
});
export const FileSourceFigma = z.object({
    type: z.literal("Figma"),
    renderMode: FileFigmaRenderMode,
});
export const FileSource = z.discriminatedUnion("type", [
    FileSourceUpload,
    FileSourceFigma,
]);
export const File = z.object({
    id: z.string(),
    name: z.string(),
    deduplicationKey: z.string(),
    pendingUpload: z.boolean().optional(),
    storagePath: z.string(),
    url: z.string(),
    size: z.number(),
    /**
     * Object describing where did the file come from. Undefined source indicates a file produced by the
     * system (e.g. thumbnails, etc)
     */
    source: FileSource.optional(),
});
export const FileReference = File.pick({
    id: true,
    url: true,
    source: true,
}).extend({
    name: File.shape.name.optional(),
});
